import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import Header from "../../Componentes/header";
import Footer from "../../Componentes/footer";
import "../../CSS/bootstrap.min.css";
import "../../CSS/style.css";
import Fetch from "../../Auxiliares/fetch";
import { toast } from "react-toastify";
import Nav from "./Componentes/aspiranteNav";

export default class AspiranteNuevoIngreso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
    this.actualizarLista = this.actualizarLista.bind(this);
  }

  componentDidMount() {
    this.actualizarLista();
  }

  actualizarLista() {
    Fetch("/api/getNuevoIngreso", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ficha: sessionStorage.getItem("ficha") }),
    })
      .then((response) => {
        this.setState({ data: response.data });
      })
      .catch((err) => {
        switch (err.status) {
          case 404:
            toast.error("Servicio no disponible");
            break;

          default:
            toast.error("Se produjo un error de conexion");
            break;
        }
      });
  }

  render() {
    return (
      <html>
        <Header />
        <Row>
          <Col className="bg-light" lg="3">
            <Nav
              nombre_completo={
                sessionStorage.getItem("nombre") +
                " " +
                sessionStorage.getItem("ap_paterno") +
                " " +
                sessionStorage.getItem("ap_materno")
              }
            />
          </Col>

          <Col className="bg-light" lg="9">
            <div id="page-content-wrapper">
              <div class="container-fluid">
                <Container>
                  {this.state.data !== null ? (
                    <div class="mt-5 mb-5 w-100 h-100 text-center card">
                      <div class="pt-5 px-5 pb-5">
                        <div class="d-inline-block font-weight-bold">
                          <p>Bienvenido Búfalo</p>
                        </div>

                        <p className="text-justify">
                          Te damos la más cordial bienvenida, a partir de este
                          momento formas parte de la comunidad estudiantil del
                          TecNM campus Mexicali – Instituto Tecnológico de
                          Mexicali.
                        </p>

                        <p className="text-justify">
                          Te pedimos <b>guardar</b> los siguientes datos, ya que
                          te permitirán acceder en cualquier parte al{" "}
                          <a
                            href="https://itmexicali.mindbox.app/login/alumno"
                            target="_blank"
                          >
                            Sistema de Gestión Escolar
                          </a>{" "}
                          <b>(MindBox)</b>. Dicho sistema te permitirá consultar
                          tu horario de clases, así como docentes asignados,
                          temarios de cada una de las materias, y calificaciones
                          de tus materias al finalizar el semestre. Así mismo,
                          el MindBox te permitirá realizar tu reinscripción en
                          línea a partir del 2do semestre, así como conocer tus
                          calificaciones de semestres anteriores conforme vayas
                          avanzando a lo largo de tu carrera profesional.
                        </p>

                        <p className="text-justify">
                          El número de control, es el número que se te asigna
                          para identificarte como estudiante del Instituto
                          Tecnológico de Mexicali, el cual te servirá para
                          acceder a servicios.
                        </p>

                        <p className="text-justify">
                          <b>Número de control del estudiante:</b>{" "}
                          {this.state.data.noControl}
                        </p>

                        <p className="text-justify">
                          Para acceder al Sistema de Gestión Escolar (Mindbox) deberás
                          ingresar a la siguiente liga:{" "}
                          <a
                            href="https://itmexicali.mindbox.app/login/alumno"
                            target="_blank"
                          >
                            https://itmexicali.mindbox.app/login/alumno
                          </a>
                          , e introducir el usuario y contraseña, que a
                          continuación se señalan:
                        </p>

                        <p className="text-justify">
                          <b>Usuario:</b> {this.state.data.noControl} <br></br>
                          <b>Contraseña:</b> {this.state.data.nip}
                        </p>

                        <p className="text-justify">
                          El inicio de clases es a partir del
                          <b>
                             21 de agosto de 2023
                          </b>
                          , para lo cual podrás consultar tus horarios y aulas de cada materia
                          en el sistema Mindbox. Es importante que consultes dicha información.
                        </p>

                        <p className="text-justify">
                          Así mismo, se ha creado un correo electrónico institucional, el cual 
                          podrás ingresar a través de la siguiente liga{" "}
                          <a href="http://gmail.com" target="_blank">
                            (http://gmail.com/)
                          </a>{" "}
                          e introducir correo y contraseña que se muestran a
                          continuación:
                        </p>

                        <p className="text-justify">
                          <b>Correo electrónico:</b> a
                          {this.state.data.noControl}@itmexicali.edu.mx{" "}
                          <br></br>
                          <b>Contraseña:</b> {this.state.data.contraseña}
                        </p>

                        <p className="text-justify">
                          Si tienes problemas para acceder a tu cuenta de correo
                          , te pedimos te comuniques al Centro de
                          Cómputo enviando correo electrónico a la siguiente
                          dirección:{" "}
                          <a href="correos@itmexicali.edu.mx" target="_blank">
                            correos@itmexicali.edu.mx
                          </a>
                          .
                        </p>

                        <p className="text-justify">
                          Te pedimos GUARDAR cuidadosamente los datos proporcionados tanto para acceder a Mindbox, 
			                    así como a tu correo electrónico, y cambiar la contraseña de ambos,
			                    <b> ya que esta información solo será accesible hasta el 1 de septiembre de 2023</b> en este sistema.
                        </p>

                        <p className="text-justify">
                          Si tienes alguna duda con tus clases, maestros, debes
                          comunicarte con tu coordinador de carrera para el caso de las clases, 
                          o bien con el jefe del departamento académico correspondiente a tu carrera 
                          para el caso de los maestros, cuyos
                          correos de contacto se encuentra en la{" "}
                          <a href="http://www.itmexicali.edu.mx/" target="_blank">
                            convocatoria para aspirantes a nuevo ingreso
                          </a>{" "} ubicada en la página del Tecnológico en el menú de Aspirantes,
                          al final de dicho documento, y quienes podrán
                          brindarte orientación.
                        </p>

                        <p className="text-justify">
                          Así mismo, te pedimos sigas a los diferentes
                          departamentos a través de las redes sociales de
                          Facebook, para conocer los servicios que dichos
                          departamentos ofrecen y puedan apoyarte en trámites
                          relacionados a su departamento.
                        </p>

                        <p className="text-justify">
                          <table className="table-bordered w-100 mx-auto">
                            <tr>
                              <th className="p-3 text-center">
                                TecNM campus Mexicali
                              </th>
                              <th className="p-3 text-center">
                                Curso C Búfalo
                              </th>
                              <th className="p-3 text-center">
                                Centro de Idiomas
                              </th>
                              <th className="p-3 text-center">
                                Gestión y Vinculación Tecnológica
                              </th>
                            </tr>

                            <tr>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/2CRhuvW"
                                  target="_blank"
                                >
                                  https://bit.ly/2CRhuvW
                                </a>
                              </td>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/3aOFQmJ"
                                  target="_blank"
                                >
                                  https://bit.ly/3aOFQmJ
                                </a>
                              </td>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/31mIFYX"
                                  target="_blank"
                                >
                                  https://bit.ly/31mIFYX
                                </a>
                              </td>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/3l9gggR"
                                  target="_blank"
                                >
                                  https://bit.ly/3l9gggR
                                </a>
                              </td>
                            </tr>

                            <tr>
                              <td> </td>
                              <td> </td>
                              <td> </td>
                              <td> </td>
                            </tr>

                            <tr>
                              <th className="p-3 text-center">
                                Extraescolares
                              </th>
                              <th className="p-3 text-center">
                                Servicio Social
                              </th>
                              <th className="p-3 text-center">
                                Centro de Cómputo
                              </th>
                              <th className="p-3 text-center">
                                Servicios Escolares
                              </th>
                            </tr>

                            <tr>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/2FRDg3W"
                                  target="_blank"
                                >
                                  https://bit.ly/2FRDg3W
                                </a>
                              </td>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/2FHb6Zd"
                                  target="_blank"
                                >
                                  https://bit.ly/2FHb6Zd
                                </a>
                              </td>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/31o9Brk"
                                  target="_blank"
                                >
                                  https://bit.ly/31o9Brk
                                </a>
                              </td>
                              <td className="p-3 text-center">
                                <a
                                  href="https://bit.ly/34qfy96"
                                  target="_blank"
                                >
                                  https://bit.ly/34qfy96
                                </a>
                              </td>
                            </tr>
                          </table>
                        </p>

                        <p className="text-justify">
                          <b>
                            Si por alguna razón tus datos en el Sistema de
                            Gestión Escolar (Mindbox) se encuentran incorrectos
                          </b>
                          , como lo es en el nombre, CURP, etc., te pedimos{" "}
                          <b>
                            envíes correo electrónico a partir del 28 de agosto
                            de 2023
                          </b>{" "}
                          a la siguiente dirección:{" "}
                          <a
                            href="controlescolar@itmexicali.edu.mx"
                            target="_blank"
                          >
                            controlescolar@itmexicali.edu.mx
                          </a>
                          , <b>a través de tu cuenta de correo institucional</b>
                          , indicando en el{" "}
                          <b>
                            ASUNTO del correo “CORRECCION DE DATOS – MINDBOX –
                            NUEVO INGRESO”
                          </b>
                          , y en el <b>cuerpo del correo</b> deberás indicar tu{" "}
                          <b>nombre completo, número de control y carrera</b>,
                          así como <b>adjuntar al correo la CURP</b> que deberás{" "}
                          <a href="https://www.gob.mx/curp/" target="_blank">
                            descargarla desde aquí
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div class="mt-5 mb-5 w-100 h-100 text-center card">
                      <div class="pt-5 px-5 pb-5">
                        <div class="d-inline-block font-weight-bold">
                          <p>
                            CONSULTA TU NÚMERO DE CONTROL Y CORREO A PARTIR DEL
                            16 DE AGOSTO DE 2023
                          </p>
                        </div>

                        <p className="text-justify">
                          Estimado aspirante, si ves este mensaje te invitamos a
                          consultar los motivos por los cuales puede ocurrir:
                          <br></br>
                          <br></br>
                          <ul>
                            <li className="ml-5">
                              No es fechas aún para consultar tus datos
                              generados de acuerdo a la convocatoria: a partir
                              del 16 de agosto de 2023 puedes consultar.
                            </li>
                            <li className="ml-5">
                              Tienes pendiente por subir documentos que no has
                              cargado al sistema, motivo por el cual no es
                              posible inscribirte, por lo que te invitamos a
                              realizar dicha carga de los documentos faltantes o
                              atender las observaciones enviadas a tu correo
                              electrónico en caso de rechazo. Así mismo, puedes
                              dirigirte con tu revisor asignado para mayor
                              orientación en caso de algún documento rechazado,
                              cuyo correo lo puedes encontrar en la sección de{" "}
                              <b>“Subir Documentos”</b>.
                              <ul className="ml-5">
                                <li className="ml-5">
                                  Una vez validados correctamente, toma entre 2
                                  a 4 días hábiles en generarse los datos que te
                                  acreditarán como estudiante (días hábiles Lunes a Viernes).
                                </li>
                              </ul>
                            </li>
                            <li className="ml-5">
                              Si el estatus del pago de inscripción se encuentra
                              en estatus <b>“PENDIENTE”</b>, es motivo por el
                              cual no se ha procedido a tu inscripción y por lo
                              tanto no es posible generar tu número de control.
                              Si ya realizaste el pago de inscripción y ha transcurrido más de 2 días hábiles y y éste
                              sigue en estatus <b>“PENDIENTE”</b>, te invitamos
                              a enviar correo a las siguientes 2 direcciones:{" "}
                              <a
                                href="tesoreria@itmexicali.edu.mx"
                                target="_blank"
                              >
                                tesoreria@itmexicali.edu.mx
                              </a>{" "}
                              y{" "}
                              <a
                                href="aspirantes@itmexicali.edu.mx"
                                target="_blank"
                              >
                                aspirantes@itmexicali.edu.mx
                              </a>
                              , y en el asunto del correo indicar{" "}
                              <b>“PAGO NO REFLEJADO – NUEVO INGRESO”</b>, y en
                              el cuerpo del correo indicar tu{" "}
                              <b>
                                nombre completo, numero de ficha, así como
                                adjuntar fotografía de comprobante de pago
                              </b>
                              .
                              <ul className="ml-5">
                                <li className="ml-5">
                                  Una vez reflejado el pago en sistema, toma
                                  entre 2 a 4 días hábiles en generarse los
                                  datos que te acreditarán como estudiante (días hábiles Lunes a Viernes).
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  )}
                </Container>
              </div>
            </div>
          </Col>
        </Row>
        <Footer />
      </html>
    );
  }
}

